module.exports = __webpack_public_path__ + "static/media/aneesh_topkar.e8b4895b.png";